import { Redirect } from 'react-router-dom';
import { MYLEARNING_URL_FRAGMENT } from '../../../constants/Navigation';
import { MyLearningTabs } from './MyLearningTabs';
import { jsx as _jsx } from "react/jsx-runtime";
export const RedirectToMyLearning = () => /*#__PURE__*/_jsx(Redirect, {
  to: MYLEARNING_URL_FRAGMENT
});
export default MyLearningTabs;